import './SamFundDataListBlock.scss';

// Async boundary required by Module Federation — see the fund page entry for
// the full explanation. Shared modules (React via loadShare) must only be
// touched after the federation runtime has initialized, otherwise WebKit/iOS
// throws "Cannot access 'X' before initialization" and the block stays blank.
//
// The resilience layer lives inside ./mount, so log here in case the mount
// chunk itself fails to load (nothing inside would catch it otherwise). Logged
// to the backend client log too (Kibana, gated by EnableClientLogging); the
// logger is imported dynamically to keep this bootstrap entry minimal.
import('./mount').catch((error) => {
  console.error('[FundData MFE] Failed to load mount chunk', error);
  void import('../../utils/logger')
    .then(({ logger }) => {
      logger.error(
        `[FundData MFE] FundList mount chunk failed to load: ${error?.message ?? error}`,
      );
    })
    .catch(() => {
      /* logging is best-effort */
    });
});
